import { render } from "./tax_component.vue?vue&type=template&id=151068e8&scoped=true"
import script from "./tax_component.vue?vue&type=script&lang=js"
export * from "./tax_component.vue?vue&type=script&lang=js"

import "./tax_component.vue?vue&type=style&index=0&id=151068e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151068e8"]])

export default __exports__